import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-edit px-2"
  }, [_c('div', [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "disabled": _vm.disabled,
      "false-value": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.rule.properties.conditionEnabled ? _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionEnabled') : _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionDisabled'),
      "inset": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('refresh-form');
      }
    },
    model: {
      value: _vm.rule.properties.conditionEnabled,
      callback: function ($$v) {
        _vm.$set(_vm.rule.properties, "conditionEnabled", $$v);
      },
      expression: "rule.properties.conditionEnabled"
    }
  })], 1), _vm.rule.properties.conditionEnabled ? [_c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionsSampleTextNoMetrics'))
    }
  }), _vm._m(0), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionsMoreLinkText')) + ":\n      "), _c('a', {
    attrs: {
      "href": "https://gitlab.com/digimondo-samples/twin-rule-samples/",
      "target": "_blank"
    }
  }, [_vm._v("\n        » DIGIMONDO Code Samples (gitlab.com)\n      ")])]), _c('core-script-editor', {
    attrs: {
      "hide-script-type-selector": "",
      "script-type": "javascript",
      "script": _vm.rule.properties.conditionScript,
      "evaluation-function": _vm.evaluateConditionScript,
      "hide-payload-inputs": ""
    },
    on: {
      "update:script": _vm.onScriptEditorChange
    },
    scopedSlots: _vm._u([{
      key: "editor-before",
      fn: function () {
        return [_c('code', [_vm._v("() => {")])];
      },
      proxy: true
    }, {
      key: "editor-after",
      fn: function () {
        return [_c('code', [_vm._v("}")])];
      },
      proxy: true
    }], null, false, 3796558864)
  })] : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('pre', {
    staticClass: "my-3 codefield"
  }, [_vm._v("const currentDate = new Date(new Date().toLocaleString('en-US', {timeZone: 'Europe/Berlin'}));\nreturn (currentDate.getHours() >= 21 || currentDate.getHours() <= 7);")])]);
}];
export { render, staticRenderFns };